import { gql } from '@apollo/client';

import { TDiscount } from './types';

export interface IDiscountsResponse {
  getAvailableDiscounts: Array<TDiscount>;
}
export const GET_AVAILABLE_DISCOUNTS = gql`
  query GetAvailableDiscounts {
    getAvailableDiscounts {
      id
      title
      value
    }
  }
`;
